import { HandleMutationResult } from 'modules/core/lib/handleMutation'

import { withFlash } from './withFlash'

type PublishMutationFn = (variables: {
  id: string
  resourceType: string
}) => HandleMutationResult<unknown>

export const createPublishAction = (publishFn: PublishMutationFn, resourceType: string) => {
  return (id: string) => withFlash(publishFn({ id, resourceType }))
}
